import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { GlobalConstant } from "../../../constants";
import { EventService, GlobalSettingService } from "../../../services";
import { ApplicationType } from "../../../constants/Enum";
import { Form } from "react-bootstrap";
import {
  formatAmount,
  handleConsoleError,
} from "../../../utils/common-methods";
import { toast } from "react-toastify";

const RetailCostings = ({ eventId, pitchId }) => {
  const [eventPitches, setEventPitches] = useState([]);
  const [furnitureTotal, setFurnitureTotal] = useState(0);
  const [electricalTotal, setElectricalTotal] = useState(0);
  const [expandedPitches, setExpandedPitches] = useState({});

  const {
    register,
    setValue,
    getValues,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();
  const [isOpen, setIsOpen] = useState(false);
  //const [size, setSize] = useState(1); // Default to single option visible
  const appType = getValues("appType");

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
    //setSize(isOpen ? 1 : 2); // Set to 5 when open, and 1 when closed
  };
  const getKeyValueByKeyName = (keyName) => {
    const entry = getValues("retailApplicationFormData.globalSettings")?.find(
      (item) => item.keyName === keyName
    );
    return entry ? entry.keyValue : null;
  };
  const toggleDescription = (pitchId) => {
    setExpandedPitches((prevState) => ({
      ...prevState,
      [pitchId]: !prevState[pitchId],
    }));
  };

  const renderPitchDescription = (pitch) => {
    const isExpanded = expandedPitches[pitch?.id];
    const maxLength = 190;
    const description = pitch?.description || "";
    const truncatedDescription =
      description.length > maxLength && !isExpanded
        ? `${description.substring(0, maxLength)}...`
        : description;

    return (
      <div style={{ marginTop: "8px" }}>
        <h3>Description</h3>
        <p
          dangerouslySetInnerHTML={{
            __html: truncatedDescription,
          }}
        ></p>
        {description.length > maxLength && (
          <a
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              toggleDescription(pitch.id);
            }}
            className="toggle-text"
          >
            {isExpanded ? "Show Less" : "Show More"}
          </a>
        )}
      </div>
    );
  };
  const calculateFurnitureTotal = () => {
    const additionalPassesPrice =
      Number(getKeyValueByKeyName(GlobalConstant.ADDITIONAL_PASSES_PRICE)) *
        Number(getValues("retailApplicationFormData.additionalpasses")) || 0;

    const bannerRailPrice = watch(
      "retailApplicationFormData.bannerrailfortents"
    )
      ? Number(getKeyValueByKeyName(GlobalConstant.BANNER_RAIL_FOR_TENTS_PRICE))
      : 0;

    const trestleTablePrice = watch("retailApplicationFormData.trestletable")
      ? Number(getKeyValueByKeyName(GlobalConstant.TRESTLE_TABLE_PRICE))
      : 0;

    // Add other conditions here if needed
    const newTotal =
      additionalPassesPrice + bannerRailPrice + trestleTablePrice;

    setFurnitureTotal(newTotal);
  };
  const calculateElectricalTotal = () => {
    const twinsockets13ampPrice =
      Number(getValues("retailApplicationFormData.twinsockets13ampPrice")) || 0;

    const amp16Price = watch("retailApplicationFormData.amp16Price")
      ? Number(getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE))
      : 0;

    const amp32Price = watch("retailApplicationFormData.amp32Price")
      ? Number(getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE))
      : 0;

    // Add other conditions here if needed
    const newTotal = twinsockets13ampPrice + amp16Price + amp32Price;

    setElectricalTotal(newTotal);
  };

  const getPrice = (pitch, matchingPitch) => {
    if (
      appType === ApplicationType.Fixed ||
      appType === ApplicationType.Turnover
    ) {
      return pitch?.amount;
    }
    if (appType === ApplicationType.Tender || appType === ApplicationType.Bid) {
      return matchingPitch?.pitchPrice || pitch?.amount;
    }
    // if (appType === ApplicationType.Bid) {
    //   return pitch?.currentBidAmount || pitch?.amount;
    // }
  };

  const getRetailCostingDetails = async () => {
    try {
      const response = await GlobalSettingService.getEventGlobalSettingList(
        eventId
      );

      if (response?.isSuccess && response?.data?.length > 0) {
        setValue(
          "retailApplicationFormData.globalSettings",
          response?.data || []
        );
        const initialTrestleTable = getValues(
          "retailApplicationFormData.trestletable"
        );
        // const initialTrestleTablePrice =
        //   getValues("retailApplicationFormData.trestletablePrice") || 0;
        const initialBannerrailfortents = getValues(
          "retailApplicationFormData.bannerrailfortents"
        );
        // const initialBannerrailfortentsPrice =
        //   getValues("retailApplicationFormData.bannerrailfortentsPrice") || 0;
        const initialAdditionalpasses = getValues(
          "retailApplicationFormData.additionalpasses"
        );
        // const initialAdditionalpassesPrice =
        //   getValues("retailApplicationFormData.additionalpassesPrice") || 0;

        setValue(
          "retailApplicationFormData.additionalpassesPrice",
          getKeyValueByKeyName(GlobalConstant.ADDITIONAL_PASSES_PRICE)
        );
        setValue(
          "retailApplicationFormData.vat",
          getKeyValueByKeyName(GlobalConstant.VAT_PERCENT)
        );
        setValue(
          "retailApplicationFormData.adminFee",
          getKeyValueByKeyName(GlobalConstant.ADMIN_RETAIL_FEE)
        );
        setValue(
          "retailApplicationFormData.processPercent",
          getKeyValueByKeyName(GlobalConstant.PROCESS_PERCENT)
        );
        setValue("retailApplicationFormData.trestletable", initialTrestleTable);
        setValue(
          "retailApplicationFormData.trestletablePrice",
          getKeyValueByKeyName(GlobalConstant.TRESTLE_TABLE_PRICE)
        );
        setValue(
          "retailApplicationFormData.bannerrailfortents",
          initialBannerrailfortents
        );
        setValue(
          "retailApplicationFormData.bannerrailfortentsPrice",
          getKeyValueByKeyName(GlobalConstant.BANNER_RAIL_FOR_TENTS_PRICE)
        );
        setValue(
          "retailApplicationFormData.additionalpasses",
          initialAdditionalpasses || 0
        );
        // setValue(
        //   "retailApplicationFormData.additionalpassesPrice",
        //   initialAdditionalpassesPrice
        // );
      }
      const res = await EventService.getPitchById(pitchId);
      if (res && res?.data) {
        const activePitches = [res?.data]; //.filter((pitch) => pitch.isActive);
        activePitches.forEach((pitch) => {
          pitch.baseAmount = pitch?.amount;
          pitch.turnOverAmount = pitch?.amount;
          if (!pitch.currentBidAmount) pitch.currentBidAmount = pitch?.amount;
        });
        setEventPitches(activePitches);
        const initialSelectedPitches =
          getValues(
            "retailApplicationFormData.objEventApplicationRetailPitchDtlViewModel"
          ) || [];

        const populatedPitches = activePitches.filter((pitch) =>
          initialSelectedPitches.some(
            (selected) => selected.pitchId === pitch.id
          )
        );

        populatedPitches.forEach((pitch) => {
          const matchingPitch = initialSelectedPitches.find(
            (p) => p.pitchId === pitch.id
          );
          if (matchingPitch) {
            pitch.pitchQty = matchingPitch.pitchQty || 0;
            const updatedPrice = getPrice(pitch, matchingPitch);
            pitch.amount = updatedPrice;
          }
        });

        setValue("retailApplicationFormData.selectedPitches", populatedPitches);
        const updatedPitch = populatedPitches
          .filter((p) => p.pitchQty > 0)
          .map((p) => ({
            pitchId: p?.id,
            pitchPrice: p?.amount,
            pitchQty: p?.pitchQty,
            // currentBidAmount: p.currentBidAmount,
          }));

        setValue(
          "retailApplicationFormData.objEventApplicationRetailPitchDtlViewModel",
          updatedPitch
        );
        trigger("retailApplicationFormData.selectedPitches");
        // setValue(
        //   "retailApplicationFormData.objEventApplicationRetailPitchDtlViewModel",
        //   populatedPitches
        // );
        calculateFurnitureTotal();
        calculateElectricalTotal();
        //trigger("retailApplicationFormData.selectedPitches");
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const handleTrestleTableChange = (e) => {
    const isChecked = e.target.checked;

    setValue("retailApplicationFormData.trestletable", isChecked);
    setValue(
      "retailApplicationFormData.trestletablePrice",
      isChecked ? getKeyValueByKeyName(GlobalConstant.TRESTLE_TABLE_PRICE) : 0
    );

    trigger("retailApplicationFormData.trestletable");
    trigger("retailApplicationFormData.trestletablePrice");
    calculateFurnitureTotal();
  };
  const handleBannerrailfortentsChange = (e) => {
    const isChecked = e.target.checked;

    setValue("retailApplicationFormData.bannerrailfortents", isChecked);
    setValue(
      "retailApplicationFormData.bannerrailfortentsPrice",
      isChecked
        ? getKeyValueByKeyName(GlobalConstant.BANNER_RAIL_FOR_TENTS_PRICE)
        : 0
    );

    trigger("retailApplicationFormData.bannerrailfortents");
    trigger("retailApplicationFormData.bannerrailfortentsPrice");
    calculateFurnitureTotal();
  };

  const handleTwinSockets13ampChange = (e) => {
    const isChecked = e.target.checked;

    setValue("retailApplicationFormData.twinsockets13amp", isChecked);
    setValue(
      "retailApplicationFormData.twinsockets13ampPrice",
      isChecked
        ? getKeyValueByKeyName(GlobalConstant.AMP_13_TWIN_SOCKETS_PRICE)
        : 0
    );

    trigger("retailApplicationFormData.twinsockets13amp");
    trigger("retailApplicationFormData.twinsockets13ampPrice");
    calculateElectricalTotal();
  };
  const handleAmp16Change = (e) => {
    const isChecked = e.target.checked;

    setValue("retailApplicationFormData.amp16", isChecked);
    setValue(
      "retailApplicationFormData.amp16Price",
      isChecked ? getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE) : 0
    );

    trigger("retailApplicationFormData.amp16");
    trigger("retailApplicationFormData.amp16Price");
    calculateElectricalTotal();
  };
  const handleAmp32Change = (e) => {
    const isChecked = e.target.checked;

    setValue("retailApplicationFormData.amp32", isChecked);
    setValue(
      "retailApplicationFormData.amp32Price",
      isChecked ? getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE) : 0
    );

    trigger("retailApplicationFormData.amp32");
    trigger("retailApplicationFormData.amp32Price");
    calculateElectricalTotal();
  };
  useEffect(() => {
    getRetailCostingDetails();
    register("retailApplicationFormData.globalSettings");
    register("retailApplicationFormData.processPercent");
    register("retailApplicationFormData.trestletable");
    register("retailApplicationFormData.trestletablePrice");
    register("retailApplicationFormData.bannerrailfortents");
    register("retailApplicationFormData.bannerrailfortentsPrice");
    register("retailApplicationFormData.twinsockets13amp");
    register("retailApplicationFormData.twinsockets13ampPrice");
    register("retailApplicationFormData.amp32");
    register("retailApplicationFormData.amp32Price");
    register("retailApplicationFormData.amp16");
    register("retailApplicationFormData.amp16Price");
    register("retailApplicationFormData.amp32");
    register("retailApplicationFormData.amp32Price");
    register("retailApplicationFormData.selectedPitches", {
      validate: (value) =>
        value?.length > 0 || "Please select at least one pitch",
    });
  }, [register]);

  const handleDropdownChange = (e, pitch) => {
    const quantity = parseInt(e.target.value, 10);

    const updatedPitches = eventPitches.map((p) =>
      p.id === pitch.id ? { ...p, pitchQty: quantity } : p
    );

    setEventPitches(updatedPitches);

    const selectedPitches = updatedPitches
      .filter((p) => p.pitchQty > 0)
      .map((p) => ({
        pitchId: p.id,
        pitchPrice: p.amount,
        pitchQty: p.pitchQty,
      }));
    setValue("retailApplicationFormData.selectedPitches", selectedPitches);
    setValue(
      "retailApplicationFormData.objEventApplicationRetailPitchDtlViewModel",
      selectedPitches
    );
    trigger("retailApplicationFormData.selectedPitches");
  };

  const handleBidChange = (e, pitch) => {
    const value = e.target.value;
    if (!isNaN(value) && value !== "") {
      const amount = parseInt(e.target.value);

      const updatedPitches = eventPitches.map((p) =>
        p.id === pitch.id ? { ...p, amount: amount } : p
      );

      setEventPitches(updatedPitches);
      const selectedPitches = updatedPitches
        .filter((p) => p.pitchQty > 0)
        .map((p) => ({
          pitchId: p.id,
          pitchPrice: p.amount,
          pitchQty: p.pitchQty,
        }));

      setValue("retailApplicationFormData.selectedPitches", selectedPitches);
      setValue(
        "retailApplicationFormData.objEventApplicationRetailPitchDtlViewModel",
        selectedPitches
      );
      trigger("retailApplicationFormData.selectedPitches");
    } else {
      //setEventUnits([{ ...eventUnits }, { amount: "0" }]);
      const updatedPitches = eventPitches.map((p) =>
        p.id === pitch.id ? { ...p, amount: 0 } : p
      );

      setEventPitches(updatedPitches);
    }
  };
  const calculateTotalForPitch = (pitch) => {
    const quantity = pitch.pitchQty || 0;
    const amount = (pitch.amount ?? 0) * quantity;
    return formatAmount(amount);
  };

  const showBidAmount = (pitch) => {
    if (appType === ApplicationType.Fixed) {
      return (
        <label style={{ marginBottom: "0px" }}>
          {" "}
          <strong>Price £{formatAmount(pitch?.amount)}</strong>
        </label>
      );
    }
    if (appType === ApplicationType.Turnover) {
      return (
        <label style={{ marginBottom: "0px" }}>
          {" "}
          <strong>Commitment Fee £{formatAmount(pitch?.turnOverAmount)}</strong>
        </label>
      );
    }
    if (appType === ApplicationType.Tender) {
      return (
        <label style={{ marginBottom: "0px" }}>
          {" "}
          <strong>Minimum Bid £{formatAmount(pitch?.baseAmount)}</strong>{" "}
        </label>
      );
    }

    if (appType === ApplicationType.Bid) {
      return (
        <label style={{ marginBottom: "0px" }}>
          <strong>
            Minimum Starting Bid £
            {formatAmount(pitch?.currentBidAmount || pitch?.amount)}
          </strong>
        </label>
      );
    }
  };

  const getMinAmount = (pitch) => {
    if (appType === ApplicationType.Tender) {
      return formatAmount(pitch?.baseAmount);
    }

    if (appType === ApplicationType.Bid) {
      return formatAmount(pitch?.currentBidAmount);
    }
  };
  return (
    <React.Fragment>
      <div role="tabpanel" className="tab-pane" id="Submit">
        {watch("retailApplicationFormData.describesyourstand") !== "Charity" ? (
          <h2 className="retail-form-hd1">Retail/Merchandise Facility Fee</h2>
        ) : (
          <h2 className="retail-form-hd1">Charity Costings</h2>
        )}
        <div className="trader-booking-f">
          <h3>
            Please select pitches <span className="text-danger">*</span>
          </h3>

          {eventPitches.map((pitch) => (
            <div key={pitch.id}>
              <div className="row pitch-react1">
                <div
                  className="col-sm-12 col-md-3 col-lg-3"
                  style={{ marginTop: "8px" }}
                >
                  <div className="calcuater2">
                    {/* {pitch.pitchWidth}m * {pitch.pitchLength}m{" "}
                    {pitch.pitchTitle} */}
                    {pitch?.pitchTitle} ({pitch?.pitchLength}' x{" "}
                    {pitch?.pitchWidth}' Space)
                  </div>
                </div>
                <div className="col-sm-12 col-md-7 col-lg-7">
                  <div className="count-pitch" style={{ marginTop: "8px" }}>
                    <strong>{showBidAmount(pitch)}</strong>
                    <label style={{ marginBottom: "0px" }} htmlFor="dropdown">
                      Pitch Quantity:
                    </label>{" "}
                    <select
                      name={`retailApplicationFormData.selectedPitches[${pitch?.id}].pitchQty`}
                      value={pitch?.pitchQty || 0}
                      onChange={(e) => handleDropdownChange(e, pitch)}
                      onClick={handleDropdownToggle} // Toggle the dropdown open/close
                    >
                      {[...Array(pitch.maxAllowed + 1).keys()].map((num) => (
                        <option key={num} defaultValue={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                    {(appType === ApplicationType.Bid ||
                      appType === ApplicationType.Tender) && (
                      <React.Fragment>
                        Add Bid Amount :
                        <Form.Control
                          className="effect-4 bid-100"
                          maxLength={5}
                          type="text"
                          {...register(pitch.id, {
                            // required: "Please enter amount",
                            pattern: {
                              value: /^[+]?[0-9]*\.?[0-9]+$/,
                              message:
                                "Please enter a valid number greater than zero.",
                            },

                            validate: (value) =>
                              parseFloat(value) >
                                parseFloat(getMinAmount(pitch)) ||
                              "Value must be greater than equal £" +
                                getMinAmount(pitch),
                          })}
                          onChange={(e) => handleBidChange(e, pitch)}
                          defaultValue={pitch.amount}
                        />
                        {errors[pitch.id] && (
                          <span className="text-danger">
                            {errors[pitch.id]?.message}
                          </span>
                        )}
                      </React.Fragment>
                    )}
                    {/* {(appType === ApplicationType.Fixed ||
                          appType === ApplicationType.Turnover) && (
                    )} */}
                  </div>
                  {pitch.description && renderPitchDescription(pitch)}
                  <div style={{ marginTop: "8px" }}>
                    Maximum Individual Applications Allowed : {pitch?.maxAllowed}
                  </div>
                  <div style={{ marginTop: "8px" }}>
                    {pitch.refundable ? "Refundable" : "Non-Refundable"}
                  </div>
                  <div>
                    {" "}
                    {errors.retailApplicationFormData?.selectedPitches && (
                      <span className="text-danger">
                        {
                          errors?.retailApplicationFormData?.selectedPitches
                            ?.message
                        }
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2">
                  <div className="calcuater1">
                    <strong>£ {calculateTotalForPitch(pitch)}</strong>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <h2 className="retail-form-hd1" style={{ marginTop: "25px" }}>
            Additional Costings
          </h2>
          <div className="pitch-react1 row">
            <div className="col-sm-12 col-md-3 col-lg-3">
              <h3>Furniture :</h3>
            </div>

            <div className="col-sm-12 col-md-7 col-lg-7">
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={watch("retailApplicationFormData.trestletable")}
                    onChange={handleTrestleTableChange}
                  />{" "}
                  Trestle Table (£
                  {formatAmount(
                    getKeyValueByKeyName(GlobalConstant.TRESTLE_TABLE_PRICE)
                  )}
                  )
                </label>
              </div>
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={watch(
                      "retailApplicationFormData.bannerrailfortents"
                    )}
                    onChange={handleBannerrailfortentsChange}
                  />{" "}
                  Banner rail for tents (£
                  {formatAmount(
                    getKeyValueByKeyName(
                      GlobalConstant.BANNER_RAIL_FOR_TENTS_PRICE
                    )
                  )}
                  )
                </label>
              </div>
              <div className="effect-pitchs1">
                <label
                  style={{ marginRight: "5px" }}
                  htmlFor="additionalpasses"
                >
                  Additional ground passes (£
                  {formatAmount(
                    getKeyValueByKeyName(GlobalConstant.ADDITIONAL_PASSES_PRICE)
                  )}{" "}
                  each){" "}
                </label>
                <input
                  id="additionalpasses"
                  className="effect-4"
                  placeholder="Enter number of additional passes"
                  type="number"
                  {...register("retailApplicationFormData.additionalpasses")}
                  defaultValue={getValues(
                    "retailApplicationFormData.additionalpasses"
                  )}
                  onKeyUp={() => calculateFurnitureTotal()}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-2 col-lg-2">
              <div className="calcuater1">
                <strong>£ {formatAmount(furnitureTotal)}</strong>
              </div>
            </div>
          </div>

          <div className="row" style={{ paddingTop: "15px" }}>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <h3>Electrical Connection :</h3>
            </div>
            <div className="col-sm-12 col-md-7 col-lg-7">
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={watch(
                      "retailApplicationFormData.twinsockets13amp"
                    )}
                    onChange={handleTwinSockets13ampChange}
                  />{" "}
                  13 amp twin-sockets (£
                  {formatAmount(
                    getKeyValueByKeyName(
                      GlobalConstant.AMP_13_TWIN_SOCKETS_PRICE
                    )
                  )}
                  )
                </label>
              </div>
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={watch("retailApplicationFormData.amp16")}
                    onChange={handleAmp16Change}
                  />{" "}
                  16 amp (£
                  {formatAmount(
                    getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE)
                  )}
                  )
                </label>
              </div>
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={watch("retailApplicationFormData.amp32")}
                    onChange={handleAmp32Change}
                  />{" "}
                  32 amp (£
                  {formatAmount(
                    getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE)
                  )}
                  )
                </label>
              </div>
              <p
                style={{
                  color: "red",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                PERSONAL GENERATORS ARE NOT PERMITTED AT THIS EVENT
              </p>
              <p>
                Power is charged on a single connection basis per unit. If you
                require additional power above a single connection for your
                unit(s) please indicate the required number of connections
                below. Power audits will be conducted continuously throughout
                the event and anyone caught using more power than ordered will
                be asked to leave the event.
              </p>

              <p>
                You must provide at least a 20m lead to connect your unit to the
                power supply.
              </p>
              <p>
                If additional electricity is required when onsite this will be
                provided but there will be a £60 charge plus the uplift - this
                will be payable immediately. Power connection timings will be
                advised closer to the event.
              </p>
            </div>

            <div className="col-sm-12 col-md-2 col-lg-2">
              <div className="calcuater1">
                <strong>£ {formatAmount(electricalTotal)}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RetailCostings;
